<template>
  <v-layout
    raw
    wrap
    class="mt-1"
  >
    <v-flex
      xs12
      md6
    >
      <v-card>
        <v-card-text>
          <div>{{ $t('Orders') }}</div>
          <div class="display-1 primary--text">{{ totalOrders }}</div>
        </v-card-text>
      </v-card>

    </v-flex>
    <v-flex
      xs12
      md6
    >
      <v-card>
        <v-card-text>
          <div>{{ $t('Total money spent') }}</div>
          <div class="display-1 primary--text text-no-wrap">{{ totalSpent }}</div>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import Money from 'js-money'

export default {
  name: 'CustomerHeader',

  props: {
    customer: {
      type: Object,
      required: true
    }
  },

  computed: {
    totalSpent () {
      let total = null
      if (!this.customer || !Array.isArray(this.customer.orders)) {
        return 0
      }

      this.customer.orders.forEach(order => {
        let money = new Money(parseInt(order.total.amount), order.total.currency)
        if (!total) {
          total = money
        }

        total = total.add(money)
      })

      return this.$options.filters.money(total)
    },

    totalOrders () {
      return !this.customer || !Array.isArray(this.customer.orders)
        ? 0
        : this.customer.orders.length
    }
  }
}
</script>
